import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { AssetStore } from "../../../../assets/AssetsStore";
import styles from "./index.module.scss";
import Lottie from "lottie-react";
import { toast } from "react-toastify";
import CustomModal from "../../../Modals/Reusable Modals/CustomModal/CustomModal";
import useWindowDimensions from "../../../../Helpers/Hooks/useWindowDimensions";
import FileViewModal from "../../../Modals/FileViewModal/FileViewModal";
import { Popconfirm } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  RemoveFileFromServer,
  UploadFileToServer,
} from "../../../../actions/Misc";
import { findConsultationForNow } from "../../../../actions/DashboardActions";
import {
  fetch_doctor_today_appointment,
  fetch_doctor_appointment_requests,
  fetch_doctor_patientList,
} from "../../../../actions/DoctorDashboardAction";

import { getFileTypeFromFileName } from "../../../../Helpers/FileHelper";
import {
  DashboardNavIcon,
  NavIcons,
} from "../../../../assets/NavbarIcons/NavIcons";
import DashboardCard from "../../../Cards/DashboardCard/DashboardCard";
import { DashboardIcons } from "../../../../assets/dashboardv2/DsahboardIcons";
import {
  RpmStatusTriangle,
  CompletedGreen,
} from "../../../../assets/Logos/Icons";
import PatientRpmComponent from "../PatientRpmComponent/Index";

function DoctorDashboardComponent({ goToHistory }) {
  const [tabHeaders, settabHeaders] = useState([
    {
      name: "Consultation Today",
      isOnline: true,
      date: moment().format("DD-MMM-YYYY"),
    },
  ]);
  // const [tabcontens, settabcontents] = useState([]);

  const { width } = useWindowDimensions();

  // const appointmentId = "1234567"
  const currentDate = moment().format("DD-MMM-YYYY");

  // const handleBookcardClick = () => {
  //   history.push("/");
  // };

  const bottomCards = [
    // {
    //   variant: "v1",
    //   icon: DashboardIcons.BookIcon(),
    //   title: "Book a new appointment",
    //   handleClick: handleBookcardClick,
    // },
    // {
    //   variant: "v2",
    //   icon: DashboardIcons.ProfileIcon(),
    //   title: "My Health Profile",
    //   handleClick: () => {},
    // },
    // {
    //   variant: "v3",
    //   icon: DashboardIcons.FilesIcon(),
    //   title: "My Health FIles",
    //   handleClick: () => {},
    // },
    {
      variant: "v4",
      icon: DashboardIcons.YoutubeIcon(),
      title: "Our Youtube channel",
      handleClick: () => {
        window.open("https://www.youtube.com/@reemhospital");
      },
    },
    {
      variant: "v5",
      icon: DashboardIcons.HeartIcon(),
      title: "Read patient Stories",
      handleClick: () => {
        window.open("https://www.reemhospital.com/testimonials/");
      },
    },
    // {
    //   variant: "v1",
    //   icon: DashboardIcons.BookIcon(),
    //   title: "Last Invitation",
    //   handleClick: () => { },
    // },
    // {
    //   variant: "v3",
    //   icon: DashboardIcons.BookIcon(),
    //   title: "More",
    //   handleClick: () => { },
    // },
  ];

  const viewTypes = {
    DASHBOARD_VIEW: "DASHBOARD_VIEW",
    PATIENT_RPM_VIEW: "PATIENT_RPM_VIEW",
  };

  //Refs................................................

  const reportRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  //State................................................
  const [activeHeader, setActiveHeader] = useState(() => tabHeaders[0]);
  const [reports, setReports] = useState([]);
  const [toastOpen, setToastOpen] = useState(false);
  const [IsDataAvailable, setIsDataAvailable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [tabContent, setTabContent] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [isJoinnowEnable, setisJoinnowEnable] = useState(true);
  const [activeConsultationId, setactiveConsultationId] = useState("");

  const [isUploadHelperModal, setUploadHelperModal] = useState(false);
  const [fileViewModal, setFileVIewModal] = useState(false);
  const [isloaded, setIsloaded] = useState(false);
  const [clickedFile, setClickedFile] = useState(null);
  const [UserData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  const [isloggedIn, setIsloggedIn] = useState(
    UserData != null && UserData != undefined ? true : false
  );
  const [RecentActiviites, setRecentActiviites] = useState([]);
  const [consultnow, setconsultnow] = useState([]);
  const [patientlist, setPatientlist] = useState([]);
  const [view, setView] = useState(viewTypes.DASHBOARD_VIEW);

  const [AppointmentsRecentActiviites, setAppointmentsRecentActiviites] =
    useState([]);

  //useEffects
  let today = moment(new Date()).format("DD-MMM-YYYY");
  useEffect(() => {
    console.log("currentDate", currentDate);
    if (isloggedIn) {
      checkConsultationNow();
      if (!isloaded) {
        dispatch(
          fetch_doctor_today_appointment(
            UserData.userId,
            UserData.userName,
            UserData.mobileNumber
          )
        ).then((res) => {
          console.log("recent activities", res);
          if (res) {
            setIsloaded(true);
            setAppointmentsRecentActiviites(res?.appointmentDetail);
            loadappointments(res?.appointmentDetail);
            // loadappointmentrequests(res?.data);
          }
        });
        
       // loadpatientlist();
        //  loadRecentActivitites()
      }
      const interval = setInterval(() => {
        checkConsultationNow();
      }, 10000);
      return () => clearInterval(interval);
    } else {
      history.push("/signin");
    }
    // setTabContent([...tabContent, newTabContent]);
    //settabHeaders([...tabHeaders,  { name: "Consultation Today2", isOnline: true, date: moment().format('DD-MMM-YYYY') }])
  }, [AppointmentsRecentActiviites, tabContent]);

  //Functions..............................................
  const addTab = () => {
    const newTabContent = {
      title: `Tab ${tabContent.length + 1}`,
      content: `Content for tab ${tabContent.length + 1}`,
    };
    setTabContent([...tabContent, newTabContent]);
  };

  //Recent activities fetching.
  function loadRecentActivitites() {
    //patientId, email, phone
    dispatch(fetch_doctor_appointment_requests(UserData.userId)).then((res) => {
      console.log("recent activities", res);
      if (res) {
        setIsDataAvailable(true);
        const newTabs = res.map((item, index) => ({
          name: "Appoointment Request - " + item.patientName,
          id: index,
          status: item.status,
          isOnline: true,
          date: "",
          content: JSON.stringify(item),
        }));

        // setTabContent(newTabs);
        //   setTabContent([...tabContent, newTabs]);
      }
    });
  }
  //end region

  function loadappointments(res) {
    let newTabContents = [];
    // console.log("*******************start*********************");
    // console.log("befor adding tabs", tabContent);

    console.log("findUpcomingAppointment",findUpcomingAppointment(res))
   const newTabs = sort_by_key(res, "listorder").map((item, index) => ({
  name:
    item.appointmentStatus === "P"
      ? "Consultation on " + item.appointmentDate
      : item.appointmentStatus === "Cancelled by Admin"
      ? "Cancelled by Admin"
      : item.appointmentStatus === "Cancelled by Doctor"
      ? "Cancelled by Doctor"
      : item.appointmentStatus.includes("CP")
      ? "Consultation Cancelled"
      : "Consultation Completed - (" + item.appointmentDate + ")",

  id: index,
  state: item.appointmentStatus,

  status:
    item.appointmentStatus === "Cancelled by Admin" ||
    item.appointmentStatus === "Cancelled by Doctor" ||
    item.appointmentStatus === "CP"
      ? "Cancelled"
      : item.status === "Completed"
      ? "Completed"
      : "Upcoming",

  icon:
    item.appointmentStatus === "Cancelled by Admin" ||
    item.appointmentStatus === "Cancelled by Doctor" ||
    item.appointmentStatus === "CP" ? (
      <RpmStatusTriangle variant="Critical" size="15" />
    ) : item.appointmentStatus === "C" ||
      item.appointmentStatus === "PD" ||
      item.status === "Completed" ? (
      <CompletedGreen size="15" />
    ) : (
      <RpmStatusTriangle variant="normal" size="15" />
    ),

  isCompleted:
    item.status !== "Upcoming" && item.status !== "On-going" ? true : false,

  content: JSON.stringify(item),
}));

    

    console.log("...Bookings", newTabs);
    setTabContent((prev) => {
      return [...prev, ...newTabs];
    });

    // console.log("after adding upcoming tabs", tabContent); // Check if the state is updated
    // console.log("*******************end*********************");
  }

  function loadpatientlist() {
    dispatch(fetch_doctor_patientList(UserData.userId)).then((res) => {
      console.log("recent activities", res);
      if (res) {
        setPatientlist(res);
      }
    });
  }

  //For requests................

  function sort_by_key(array, key) {
    console.log("enterd in the sort function with ", array);
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

 function findUpcomingAppointment (res) {
    const appointments = res;
    const currentDateTime = new Date();

    let upcomingAppointment = null;
    let minTimeDifference = Infinity;

    appointments.forEach(appointment => {
      const appointmentTimeStr = appointment.appointmentTime;
      const [startTimeStr, endTimeStr] = appointmentTimeStr.split(" - ");

      const startTime = new Date(`${currentDate} ${startTimeStr}`);
      const endTime = new Date(`${currentDate} ${endTimeStr}`) 
      
      if (startTime > currentDateTime) {
        console.log("here*************")
        const timeDifference = startTime - currentDateTime;
        console.log("timeDifference*************",timeDifference)
        console.log("minTimeDifference*************",minTimeDifference)
        if (timeDifference < minTimeDifference) {
          minTimeDifference = timeDifference;
          upcomingAppointment = appointment;
        }
      }
    });

    return upcomingAppointment;
  };

  function checkConsultationNow() {
    dispatch(findConsultationForNow(UserData.userType, UserData.userId)).then(
      (res) => {
        console.log("checkConsultationNow", res);
        if (res.appointmentId != undefined) {
          setconsultnow(res);
          if(res.appointmentId===JSON.parse(tabContent[activeTab].content).appointmentId)
          {
            setisJoinnowEnable(false);
          }
          
          setactiveConsultationId(res.appointmentId)
          //isJoinnowEnable, setisJoinnowEnable
        }
      }
    );
  }

  

  function closeUploadHelperModal() {
    setUploadHelperModal(false);
  }



  function isOverDataAvailable() {
    if (width >= 1280 && tabContent.length > 3) {
      return true;
    } else if (width < 1280 && tabContent.length > 2) {
      return true;
    }
  }

  const closeFileViewModal = () => {
    setFileVIewModal(false);
  };

  let loadConsultation = (appointmentId) => {
    if (consultnow.appointmentId === appointmentId) {
      console.log(consultnow);
      history.push("/meetdr/" + appointmentId);
    }
  };

 

  // let downloadInvoice = (res) => {
  //   console.log(tabContent);
  //   const newTabs = {
  //     name: "Appointment Request",
  //     id: 5,
  //     isOnline: true,
  //     date: moment().format("DD-MMM-YYYY"),
  //     content: JSON.stringify(res),
  //   };

  //   setTabContent([...tabContent, newTabs]);
  // };

  // let handleGridFileClick = (type, item, key) => {
  //   setClickedFile(item);
  //   setFileVIewModal(true);
  // };
  // let handleRemoveReportClick = (data) => {
  //   console.log(data);

  //   setReports((prev) => prev.filter((each) => each.name != data.name));
  //   // dispatch(RemoveFileFromServer(data?.file?.fileName))
  // };

  const handlePatientNameClick = (patientDetails) => {
    console.log("Patient Details",patientDetails)
    //setView(viewTypes.PATIENT_RPM_VIEW);
  };

  

//console.log()
  return (
    <div className={styles.container}>
      {view === viewTypes.PATIENT_RPM_VIEW ? (
        <PatientRpmComponent />
      ) : (
        <>
          {tabContent && tabContent.length ? (
            <div className={styles.tab_wrap}>
              <div className={styles.tab_header}>
                {width >= 1399
                  ? tabContent.slice(0, 3).map((tab, index) => (
                      // <button key={index} onClick={() => setActiveTab(index)}>{tab.title}</button>
                      <div
                        onClick={() => {
                          setActiveTab(index);
                          // loadReports(index)
                          // setReports( ...reports,tabContent[activeTab]?.content?.reports!=undefined?tabContent[activeTab]?.content?.reports:"")
                        }}
                        key={index}
                        className={`${styles.tab_header_item} ${
                          activeTab === index && styles.tab_header_item_active
                        }`}
                      >
                        <div className={`${styles.status_indicator} `}>
                          {tab.icon}
                        </div>
                        <span>
                          {tab.name}&nbsp;
                          {tab.date && (
                            <div className={styles.date}>({tab.date})</div>
                          )}
                        </span>
                      </div>
                    ))
                  : tabContent.slice(0, 3).map((tab, index) => (
                      <div
                        onClick={() => {
                          setActiveTab(index);
                          // loadReports(index);
                        }}
                        key={index}
                        className={`${styles.tab_header_item} ${
                          activeTab === index && styles.tab_header_item_active
                        }`}
                      >
                        <div className={`${styles.status_indicator} `}>
                          {tab.icon}
                        </div>
                        <span>
                          {tab.name}&nbsp;
                          {tab.date && (
                            <div className={styles.date}>({tab.date})</div>
                          )}
                        </span>
                      </div>
                    ))}

                {isOverDataAvailable() ? (
                  <div className={styles.tab_header_item} onClick={goToHistory}>
                    <img
                      className={styles.action_btn}
                      src={AssetStore.dashbaodrV2.triangle}
                      alt=""
                    />
                  </div>
                ) : null}
              </div>

              {tabContent[activeTab]?.content ? (
                <div className={styles.tab_body}>
                  {activeHeader?.isCompleted ? (
                    <>
                      <div className={styles.tab_body_item}>
                        <h6>Rate this consultation - Dr John Doe</h6>

                        <div className={styles.tab_body_item_body}>
                          <div className={styles.profile_wtrap}>
                            <img
                              className={styles.avatar}
                              src={AssetStore.dashbaodrV2.user}
                              alt=""
                            />

                            <div className={styles.profile_content}>
                              {[...Array(3)].map((each, key) => {
                                return (
                                  <div
                                    key={key}
                                    className={styles.profile_content}
                                  >
                                    <div className={styles.text}>
                                      Criteria {key + 1}
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                      <div className={styles.icon}></div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          <div className={styles.tab_body_item_footer}>
                            <button>Book Now</button>
                          </div>
                        </div>
                      </div>

                      <div className={styles.tab_body_item}>
                        <h6>Follow up Appointment</h6>

                        <div className={styles.tab_body_item_body}>
                          <div className={styles.profile_wtrap}>
                            <img
                              className={styles.avatar}
                              src={AssetStore.dashbaodrV2.user}
                              alt=""
                            />

                            <div className={styles.profile_content}>
                              <div className={styles.username}>
                                {" "}
                                Dr. John Doe{" "}
                              </div>
                              <div className={styles.text}>
                                <div className={styles.icon}></div> Follow up
                                consultation recommended by Doctor in 3 weeks
                              </div>
                            </div>
                          </div>

                          <div className={styles.tab_body_item_footer}>
                            <button>Book Now</button>
                          </div>
                        </div>
                      </div>

                      <div className={styles.tab_body_item}>
                        <h6>Prescription & Invoice</h6>

                        <div className={styles.tab_body_item_body}>
                          <div className={styles.profile_wtrap}>
                            <div className={styles.profile_content}>
                              <div className={styles.profile_content}>
                                <div className={styles.text}>
                                  <div className={styles.big_icon}>
                                    <img
                                      src={AssetStore.dashbaodrV2.prescription}
                                      alt=""
                                    />
                                  </div>
                                  <Link>Download Prescription</Link>
                                </div>

                                <div className={styles.text}>
                                  <div className={styles.big_icon}>
                                    <img
                                      src={AssetStore.dashbaodrV2.prescription}
                                      alt=""
                                    />
                                  </div>
                                  <Link>Download Invoice</Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {tabContent[activeTab]?.content ? (
                        <>
                          <div className={styles.tab_body_item}>
                            <h6>Appointment Details</h6>

                            <div className={styles.tab_body_item_body}>
                              <div className={styles.profile_wtrap}>
                                <img
                                  className={styles.avatar}
                                  src={
                                    JSON.parse(tabContent[activeTab].content)
                                      .patientImage !== ""
                                      ? JSON.parse(
                                          tabContent[activeTab].content
                                        ).patientImage
                                      : AssetStore.dashbaodrV2.user
                                  }
                                  alt=""
                                />

                                <div className={styles.profile_content}>
                                  <div
                                    onClick={() => {
                                      handlePatientNameClick(
                                        JSON.parse(
                                          tabContent[activeTab].content
                                        )
                                      );
                                    }}
                                    className={styles.username}
                                  >
                                    {" "}
                                    {
                                      JSON.parse(tabContent[activeTab].content)
                                        .patientName
                                    }{" "}
                                  </div>
                                  {/* <div className={styles.text}>
                                <div className={styles.icon}>{DashboardIcons.BookIcon()}</div>{" "}
                                {
                                  JSON.parse(tabContent[activeTab].content)
                                    .reasonForVisit
                                }
                              </div> */}
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {" "}
                                      {DashboardIcons.TimeIcon()}
                                    </div>{" "}
                                    
                                    {
                                      JSON.parse(tabContent[activeTab].content)
                                        .appointmentTime
                                    }
                                  </div>
                                  {JSON.parse(tabContent[activeTab].content)
                                    .Invoice !== undefined && (
                                    <div className={styles.text}>
                                      <div className={styles.icon}>
                                        {" "}
                                        {DashboardIcons.InvoiceIcon()}
                                      </div>{" "}
                                      <a
                                        href={
                                          JSON.parse(
                                            tabContent[activeTab].content
                                          ).Invoice !== undefined
                                            ? JSON.parse(
                                                tabContent[activeTab].content
                                              ).Invoice
                                            : ""
                                        }
                                      >
                                        Download Invoice
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className={styles.tab_body_item_footer}>
                                {JSON.parse(tabContent[activeTab].content)
                                  .appointmentStatus === "P" &&
                                JSON.parse(tabContent[activeTab].content)
                                  .status !== "Completed" ? (
                                  <>
                                    <button
                                      disabled={activeConsultationId===JSON.parse(tabContent[activeTab].content).appointmentId?false:true}
                                      onClick={() => {
                                        loadConsultation(
                                          JSON.parse(
                                            tabContent[activeTab].content
                                          ).appointmentId
                                        );
                                      }}
                                    >
                                      Join Now
                                    </button>
                                    <span className={styles.normal_text}>
                                      Clickable 5 min before the scheduled time
                                    </span>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <div className={styles.tab_body_item}>
                            <h6>
                              Uploaded Reports{" "}
                              {JSON.parse(tabContent[activeTab].content)
                                .reports &&
                              JSON.parse(tabContent[activeTab].content).reports
                                .length > 0
                                ? `(${
                                    JSON.parse(tabContent[activeTab].content)
                                      .reports.length
                                  })`
                                : null}
                            </h6>

                            <div className={styles.tab_body_item_body}>
                              <div className={styles.profile_wtrap}>
                                <div className={styles.profile_content}>
                                  {JSON.parse(tabContent[activeTab].content)
                                    .reports &&
                                  JSON.parse(tabContent[activeTab].content)
                                    .reports.length > 0 ? (
                                    <div className={styles.reports_wrap}>
                                      {JSON.parse(
                                        tabContent[activeTab].content
                                      ).reports.map((e, key) => {
                                        return (
                                          <div
                                            onClick={() => {}}
                                            key={key}
                                            className={styles.text}
                                          >
                                            <img
                                              className={styles.report_icon}
                                              src={getFileTypeFromFileName(
                                                e.filetypes
                                              )}
                                              alt=""
                                            />
                                            <a
                                              href={e.filecontent}
                                              rel="noreferrer"
                                              target="_blank"
                                            >
                                              Reports-{key + 1}
                                            </a>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    <div
                                      className={
                                        styles.report_list_empty_container
                                      }
                                    >
                                      <div>
                                        <Lottie
                                          style={{ width: 80 }}
                                          animationData={
                                            AssetStore.nodataanimation
                                          }
                                          loop={true}
                                        />
                                      </div>

                                      <span
                                        className={
                                          styles.report_list_empty_container_text
                                        }
                                      >
                                        No reports
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* <div className={styles.tab_body_item_footer}>
                                <input
                                  accept={[
                                    ".pdf",
                                    ".png",
                                    ".jpeg",
                                    ".jpg",
                                    ".doc",
                                    ".docx",
                                    ".dcm",
                                    ".DCM",
                                    ".zip",
                                  ]}
                                  type="file"
                                  ref={reportRef}
                                  style={{ display: "none" }}
                                  id=""
                                  //onChange={(e) => { handleReportUpload(e.target.files[0], e,JSON.parse(tabContent[activeTab].content).appointmentId) }}
                                />
                                <button
                                //onClick={onClickUploadReport}
                                >
                                  Upload Reports
                                </button>
                                <span
                                  onClick={() => {
                                    setUploadHelperModal(true);
                                  }}
                                >
                                  Uploading guidelines?
                                </span>
                              </div> */}
                            </div>
                          </div>
                          <div className={styles.tab_body_item}>
                            <h6>Others</h6>

                            <div className={styles.tab_body_item_body}>
                              <div className={styles.profile_wtrap}>
                                <div className={styles.profile_content}>
                                  {/* <div className={styles.text}><div className={styles.icon}></div><Link>Cancel/Reschedule Appointment</Link> </div> */}
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {DashboardIcons.VideoConversationIcon()}
                                    </div>{" "}
                                    <a href="https://zoom.us/test" target="_blank">
                                    Test your computer{" "}
                                    </a>
                                  </div>
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {" "}
                                      {DashboardIcons.PatientConsent()}
                                    </div>
                                    {JSON.parse(tabContent[activeTab].content)
                                      .Consent !== undefined ? (
                                      <a
                                        href={
                                          JSON.parse(
                                            tabContent[activeTab].content
                                          ).Consent !== undefined
                                            ? JSON.parse(
                                                tabContent[activeTab].content
                                              ).Consent
                                            : ""
                                        }
                                      >
                                        Patient Consent
                                      </a>
                                    ) : (
                                      ""
                                    )}{" "}
                                    
                                    <a href="/reem/termsofUse/terms" target="_blank">
                                      Consultation T&C
                                    </a>
                                  </div>
                                  <div className={styles.text}>
                                    <div className={styles.icon}>
                                      {" "}
                                      {DashboardIcons.SupportIcon()}
                                    </div>{" "}
                                    Support :{" "}
                                    <a href="mailto:contactus@reemhospital.ae">
                                      Email
                                    </a>
                                    |<a href="tel:800-7444"> Call </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : null}
          <div className={styles.others_grid}>
            {bottomCards.map((each, key) => (
              <DashboardCard {...each} key={key} />
            ))}
          </div>
        </>
      )}

      <CustomModal
        okText="Preview"
        caption=""
        onOk={closeUploadHelperModal}
        onClose={closeUploadHelperModal}
        isShowModal={isUploadHelperModal}
      >
        <div>Supported formats - PDF, PNG, JPEG, JPG, DOC, DOCX, DCM, ZIP.</div>
        <div>File limits - 5 files of 5MB per file</div>
      </CustomModal>

      <FileViewModal
        isShowModal={fileViewModal}
        onClose={closeFileViewModal}
        file={clickedFile}
      />
    </div>
  );
}

export default DoctorDashboardComponent;
